/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Extended_Ad_HelpInputs */

const en_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extended AD pauses program audio to allow for longer audio descriptions`)
};

const fr_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'AD étendue met en pause l'audio du programme pour permettre des descriptions plus longues`)
};

const de_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Funktion „Erweiterte Audiodeskription“ unterbricht die Programmwiedergabe, um längere Audiobeschreibungen zu ermöglichen.`)
};

const it_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pubblicità estesa mette in pausa l'audio del programma per consentire descrizioni audio più lunghe`)
};

const ru_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функция расширенного AD приостанавливает воспроизведение звука программы, чтобы дать возможность добавить более длинные аудиоописания.`)
};

const es_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El AD extendido pausa el audio del programa para permitir descripciones de audio más largas`)
};

const zh_cn2_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`加长版音频描述会暂停节目音频，以便进行更长时间的音频描述。`)
};

const ja_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`拡張ADはプログラムの音声を一時停止し、より長い音声説明を可能にします`)
};

const hi_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`विस्तारित विज्ञापन कार्यक्रम के ऑडियो को रोक देता है ताकि लंबे ऑडियो विवरण दिए जा सकें।`)
};

const pt_pt2_audio_description_export_extended_ad_help = /** @type {(inputs: Audio_Description_Export_Extended_Ad_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A função Extended AD pausa o áudio do programa para permitir descrições de áudio mais longas.`)
};

/**
* | output |
* | --- |
* | "Extended AD pauses program audio to allow for longer audio descriptions" |
*
* @param {Audio_Description_Export_Extended_Ad_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_extended_ad_help = /** @type {((inputs?: Audio_Description_Export_Extended_Ad_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Extended_Ad_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_audio_description_export_extended_ad_help(inputs)
	if (locale === "de") return de_audio_description_export_extended_ad_help(inputs)
	if (locale === "it") return it_audio_description_export_extended_ad_help(inputs)
	if (locale === "ru") return ru_audio_description_export_extended_ad_help(inputs)
	if (locale === "es") return es_audio_description_export_extended_ad_help(inputs)
	if (locale === "zh-CN") return zh_cn2_audio_description_export_extended_ad_help(inputs)
	if (locale === "ja") return ja_audio_description_export_extended_ad_help(inputs)
	if (locale === "hi") return hi_audio_description_export_extended_ad_help(inputs)
	if (locale === "pt-PT") return pt_pt2_audio_description_export_extended_ad_help(inputs)
	return en_audio_description_export_extended_ad_help(inputs)
});